import React, { useEffect } from "react";
import { Navigate } from "react-router-dom"; // For navigating after logout
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useState } from "react";

// Material UI Components
import { Card } from "@mui/material";

function LogOut() {
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    // Clear any session data or authentication tokens here
    localStorage.removeItem('user');
    setRedirect(true); // Immediately trigger the redirect
    // Redirect after 2 seconds or you can handle this immediately
    // setTimeout(() => {
    //   setRedirect(true);
    // }, 10000); // 2 seconds delay before redirecting
  }, []);

  if (redirect) {
    // return <Navigate to="/authentication/sign-in" />;
    return <Navigate to="/home" />;
  }

  return (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ backgroundColor: "#f5f5f5" }}
    >
      <Card sx={{ maxWidth: 400, textAlign: "center", padding: 3 }}>
        <MDBox>
          <MDTypography variant="h4" fontWeight="medium" color="primary" mb={3}>
            You have been logged out
          </MDTypography>
          <MDTypography variant="body1" color="text.secondary" mb={4}>
            You successfully logged out. Thank you for using our service. You will be redirected to the sign-in page shortly.
          </MDTypography>

          <MDButton
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => setRedirect(true)} // Instant redirection if user clicks
            sx={{
              background: "#4a65d8", // Initial background color
              "&:hover": {
                background: "#6281eb", // Hover state color
              },
            }}
          >
            Go to Sign-In Page
          </MDButton>
        </MDBox>
      </Card>
    </MDBox>
  );
}

export default LogOut;
